// Modules
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

// Languages
import { LN_AUTH_EMAIL } from 'locales/constants'

// Components
import { ErrorMessage, InputBase } from 'components'
import { formConstants } from 'pages/Auth/Login/LoginForm/constants'

// UI
import { FormControl, FormLabel, InputGroup } from '@chakra-ui/react'

const EmailField = (props) => {
  const { formik, placeholder, isLabel = true } = props

  const { t } = useTranslation()

  const { email } = formConstants

  return (
    <FormControl isRequired mb={3}>
      {isLabel && <FormLabel>{t(LN_AUTH_EMAIL)}</FormLabel>}

      <InputGroup>
        <InputBase
          type="email"
          {...formik.getFieldProps(email)}
          placeholder={placeholder ? t(LN_AUTH_EMAIL) : ''}
        />
      </InputGroup>
      {formik.touched[email] && formik.errors[email] && (
        <ErrorMessage error={t(formik.errors[email])} fontSize="sm" />
      )}
    </FormControl>
  )
}

export default memo(EmailField)
